<template>
  <div class="home">
    <SaleCommissionList v-show="listView" @newSales="onClickNewFromList" @editSales="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <SaleCommissionForm v-show="formView" :comm="comm" @backClicked="onBackChild" @backReload="backReload" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import SaleCommissionList from '@/components/sales/SaleCommissionList.vue'
import SaleCommissionForm from '@/components/sales/SaleCommissionForm.vue'
import { mapState } from 'vuex'
import { getHeader, saleCommissionUrl } from '../config'

export default {
  name: 'SaleCommission',
  components: {
    SaleCommissionForm,
    SaleCommissionList
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      comm: {
        id: null,
        name: null,
        amount: null,
        percentage: '0',
        percentage_age_limit: '0',
        age: '0',
        age_limit: '0',
        company_no: null,
        company: null,
        notes: null,
        type: null,
        active: false,
        products: [{
          id: null,
          commission_id: null,
          product_no: null
        }],
        omzets: [{
          id: null,
          commission_id: null,
          amount: '0',
          amount2: '0',
          fee: '0'
        }],
        customers: [{
          id: null,
          commission_id: null,
          customer_no: null,
          notes: null
        }]
      }
    }
  },
  methods: {
    async backReload (id) {
      await axios.get(saleCommissionUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          this.onClickEditFromList(response.data.data)
        })
        .catch(error => {
          this.$swal(
            'Error!!!',
            error.response.data.message,
            'error'
          )
        })
    },
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.comm = value
    },
    getEditSales: function (value) {
    //   console.log(saleOrderUrl + '/' + value)
      axios.get(saleCommissionUrl + '/' + value, { headers: getHeader() })
        .then(response => {
          this.listView = false
          this.formView = true
          this.comm = response.data.data
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.comm = {
        id: null,
        name: null,
        amount: '0',
        percentage: '0',
        percentage_age_limit: '0',
        age: null,
        age_limit: null,
        company_no: this.authUser.company_no,
        company: null,
        notes: null,
        type: 'product',
        active: true,
        products: [],
        omzets: [],
        customers: []
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.comm = {
        id: null,
        name: null,
        amount: '0',
        percentage: '0',
        percentage_age_limit: '0',
        age: null,
        age_limit: null,
        company_no: null,
        company: null,
        notes: null,
        type: null,
        active: false,
        products: [{
          id: null,
          commission_id: null,
          product_no: null
        }],
        omzets: [{
          id: null,
          commission_id: null,
          amount: '0',
          amount2: '0',
          fee: '0'
        }],
        customers: [{
          id: null,
          commission_id: null,
          customer_no: null,
          notes: null
        }]
      }
      this.$refs.refreshList.refreshList()
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      companyList: state => state.companies.companyList
    })
  },
  mounted () {
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getProductListSelect', { status: null })
    this.$store.dispatch('getCustomerList')
  }
}
</script>
